import { ItemCategory } from '../types';

export const CATEGORIES: ItemCategory[] = [
  'electronics', 'clothing', 'accessories', 'books',
  'sports', 'jewelry', 'keys', 'bags', 'other'
];

export const LOCATIONS = [
  'Main Building', 'Gymnasium', 'Cafeteria', 'Library',
  'Science Lab', 'Art Room', 'Music Room', 'Sports Field',
  'Parking Lot', 'Other'
] as const;

// Shared form styles
export const inputClass = 'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500';
export const labelClass = 'block text-sm font-medium text-gray-700 mb-1';

export const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);